export default "__VITE_ASSET__JnIqZEzE__"